import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ComponentFactoryResolver,
  ComponentRef,
  ComponentFactory,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  QueryList,
  Type} from '@angular/core';
import { Subscription } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { PartConfig } from './config/part-components';
import {TaskService} from '../../services/task.service';

@Component({
  selector: 'nf-automation',
  templateUrl: './automation.component.html',
  styleUrls: ['./automation.component.css'],
})
export class AutomationComponent implements OnInit, OnDestroy {
  boardData: any = {}; // 面板数据
  boardName = ''; // 面板名称
  type: string; // 存放当前类型 integrations 集成 automations 自动化
  typeText: string;
  dataSubscription: Subscription = null;
  categoryData: Array<any> = []; // 菜单数据
  recipeData: Array<any> = []; // 实例数据
  recipeAllData: Array<any> = []; // 实例所有数据
  currentMenuId: number; // 存放当前菜单ID
  currentMenuName: string; // 存放当前菜单名称
  isVisible = false; // 模板弹窗是否可见
  isConfirmLoading = false; // 模板弹窗按钮LOADING
  isConfirmDisabled = true; // 模板弹窗按钮不可点
  partSubmitData: any = {}; // 存放模板提交数据
  automationData: any; // 存放自动化实例列表数据
  automationPageData: any; // 存放带分页实例列表数据
  pageIndex = 1;                     // 当前页
  pageSize = 10;                     // 分页大小
  total = 0;                         // 总条数
  currentTab = 0; // tab页激活面板
  currentInstanceId = ''; // 当前实例ID
  isEdit: boolean; // 实例是否编辑状态
  categorieId: string; // 存放当前目录ID
  searchKey: string; // 搜索关键字
  isSpinning = false;
  listType = 'card';
  isAutomationSpinning = false;
  appId: string; // 对接外部应用Id
  @Input('nfBoardData') set changeData(data: any) {
    if (data) {
      this.boardData = data;
      this.getData();
      // if (data['id']) {
      //   this.taskService.getBoardData(data['id']).subscribe((res: any) => {
      //     if (res) {
      //       this.boardData = res;
      //     } else {
      //       this.boardData = data;
      //     }
      //     this.getData();
      //     this.boardName = this.boardData.name;
      //   }, () => {
      //     this.isSpinning = false;
      //   });
      // }
    }
  }
  @Input('nfType') set changeType(val: any) {
    this.type = val;
    this.typeText = this.type === 'integrations' ? '集成监听' : '自动化';
  }
  @ViewChild('dynamicComponentContainer', { read: ViewContainerRef, static: true }) container; // 创建动态组件容器
  componentRef: ComponentRef<any>;
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private modal: NzModalService,
    private componentFactory: ComponentFactoryResolver,
  ) { }

  ngOnInit() {
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
  // 获取集成数据
  getData() {
    const param = {
      'boardId': this.boardData.id,
      entity: this.type
    };
    this.dataSubscription = this.taskService.getIntegrationData(param).subscribe((res: any) => {
      this.isSpinning = false;
      if (res) {
        this.recipeAllData = [];
        this.recipeData = [];
        this.categoryData = [];
        const data = res;
        this.recipeAllData = data.recipes;
        // 处理菜单
        if (data.hasOwnProperty('categories')) {
          data.categories.forEach((item, index) => {
            this.categoryData.push(item);
          });
        }
        this.currentMenuId = this.categoryData[0] ? this.categoryData[0].id : null;
        this.currentMenuName = this.categoryData[0] ? this.categoryData[0].title : null;
        // 处理自动化列表
        const arr = [];
        for (let i = 0; i < this.categoryData[0].relationIds.length; i++) {
          this.recipeAllData.forEach((list, n) => {
            if (this.categoryData[0].relationIds[i] === list.relationId) {
              list.parentId = this.categoryData[0].id;
              arr.push(list);
            }
          });
        }
        for (let i = 0; i < arr.length % 3; i++) {
          arr.push(null);
        }
        this.recipeData = arr.reduce((pre, next, idx) => {
          const inner = pre[~~(idx / 3)];
          if (inner !== undefined) {
            inner.push(next);
          } else {
            pre.push([next]);
          }
          return pre;
        }, [[]]);
        this.getAutomationsData();
      }
    }, () => {
      this.isSpinning = false;
    });
  }
  // 菜单点击事件
  handleMenuChange(menu) {
    this.currentMenuId = menu.id;
    this.currentMenuName = menu.title;
    // 处理列表
    const arr = [];
    for (let i = 0; i < menu.relationIds.length; i++) {
      this.recipeAllData.forEach((list, n) => {
        if (menu.relationIds[i] === list.relationId) {
          list.parentId = menu.id;
          arr.push(list);
        }
      });
    }
    for (let i = 0; i < arr.length % 3; i++) {
      arr.push(null);
    }
    this.recipeData = arr.reduce((pre, next, idx) => {
      const inner = pre[~~(idx / 3)];
      if (inner !== undefined) {
        inner.push(next);
      } else {
        pre.push([next]);
      }
      return pre;
    }, [[]]);
  }
  // 弹窗确定事件
  handleOk() {
    this.isConfirmLoading = true;
    if (this.isEdit) {
      this.dataSubscription = this.taskService.patchAutomations(this.currentInstanceId, this.partSubmitData).subscribe((res: any) => {
        this.message.create('success', '编辑成功！');
        this.isVisible = false;
        this.isConfirmLoading = false;
        this.getAutomationsData();
        this.currentTab = 1;
      }, (err) => {
        this.isConfirmLoading = false;
      });
    } else {
      this.dataSubscription = this.taskService.addAutomations(this.partSubmitData).subscribe((res: any) => {
        this.message.create('success', '新增成功！');
        this.isVisible = false;
        this.isConfirmLoading = false;
        this.getAutomationsData();
        this.currentTab = 1;
      }, (err) => {
        this.isConfirmLoading = false;
      });
    }
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 处理模板弹窗事件
  handleRecipeEvent(code, recipe) {
    this.isVisible = true;
    this.categorieId = recipe.parentId;
    if (recipe.app) {
     this.appId = recipe.app;
    }
    this.createComponent(code, recipe, recipe.id, recipe.relationId, null, false, recipe.smsPattern);
  }
  // 动态创建组件
  private createComponent(code: string, recipe, recipeId?: string, relationId?: string, instance?: any, idEdit?: boolean, smsPattern?) {
    this.container.clear();
    const targetComponent: Type<any> = PartConfig[code];
    const factory: ComponentFactory<any> = this.componentFactory.resolveComponentFactory(targetComponent);
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.boardData = this.boardData;
    this.componentRef.instance.recipe = recipe;
    this.componentRef.instance.recipeId = recipeId;
    this.componentRef.instance.relationId = relationId;
    this.componentRef.instance.categorieId = this.categorieId;
    this.componentRef.instance.smsPattern = smsPattern;
    if (this.appId) {
      this.componentRef.instance.appId = this.appId;
    }
    if (instance) {
      this.componentRef.instance.instanceData = instance;
    }
    this.isEdit = idEdit;
    this.isConfirmDisabled = true;
    // 订阅子组件方法
    this.componentRef.instance.nfDataChange.subscribe(event => {
      this.partSubmitData.config = event;
      this.partSubmitData.config.boardId = this.boardData.id;
      this.partSubmitData.boardId = this.boardData.id;
      this.partSubmitData.recipeId = recipeId;
      this.partSubmitData.relationId = relationId;
      this.partSubmitData.config.relationId = relationId;
      // 控制了模板的 列/组/定时/when/任务 影响提交按钮
      setTimeout(() => {
        this.isConfirmDisabled = !this.componentRef.instance.getSubmitStatus();
      }, 100);
    });
  }
  // tab切换点击事件
  automationClickTab(event) {
    if (event === '1') {
      this.getData();
    } else if (event === '2') {
      if (this.listType === 'card') {
        this.getAutomationsData();
      } else {
        this.getAutomationPagesData();
      }
    }
  }
  // 跳转自动化模板列表
  goToAddAutomations() {
    this.currentTab = 0;
  }
  // 获取自动化实例列表
  getAutomationsData() {
    this.isAutomationSpinning = true;
    const param = {
      'boardId': this.boardData.id,
      entityType: this.type
    };
    this.dataSubscription = this.taskService.getAutomations(param).subscribe((res: any) => {
      this.isAutomationSpinning = false;
      if (res) {
        this.automationData = res.data || [];
        if (this.automationData) {
          this.automationData.forEach((item, index) => {
            if (item.status === 'on') {
              item.active = true;
            } else if (item.status === 'off') {
              item.active = false;
            }
            if (this.recipeAllData && this.recipeAllData.length > 0) {
              this.recipeAllData.forEach((m, i) => {
                if (m.relationId === item.config.relationId) {
                  this.automationData[index].partCode = m.partCode;
                  this.automationData[index].parsedSentence = m.parsedSentence;
                  this.automationData[index].sentence = m.sentence;
                  this.automationData[index].sentenceTerms = m.sentenceTerms;
                }
              });
            }
          });
        }
      }
    }, () => {
      this.isAutomationSpinning = false;
    });
  }
  // 获取带分页自动化实例列表
  getAutomationPagesData() {
    this.isAutomationSpinning = true;
    let param = {};
    if (this.total !== 0) {
      param = {
        boardId: this.boardData.id,
        page: this.pageIndex,
        rows: this.pageSize,
        total: this.total
      };
    } else {
      param = {
        boardId: this.boardData.id,
        page: this.pageIndex,
        rows: this.pageSize
      };
    }
    this.dataSubscription = this.taskService.getAutomationPages(param).subscribe((res: any) => {
      this.isAutomationSpinning = false;
      if (res) {
        this.automationPageData = res.data ? res.data : [];
        this.total = res.page.totalElements;
        this.pageIndex = res.page.number;
        if (this.automationPageData) {
          this.automationPageData.forEach((item, index) => {
            if (item.status === 'on') {
              item.active = true;
            } else if (item.status === 'off') {
              item.active = false;
            }
            if (this.recipeAllData && this.recipeAllData.length > 0) {
              this.recipeAllData.forEach((m, i) => {
                if (m.relationId === item.config.relationId) {
                  this.automationPageData[index].partCode = m.partCode;
                  this.automationPageData[index].parsedSentence = m.parsedSentence;
                  this.automationPageData[index].sentence = m.sentence;
                  this.automationPageData[index].sentenceTerms = m.sentenceTerms;
                }
              });
            }
          });
        }
        console.log(this.automationPageData)
      }
    }, () => {
      this.isAutomationSpinning = false;
    });
  }
  // 切换实例状态
  switchInstanceStatus(event, id) {
    const param = {
      'active': event
    };
    this.dataSubscription = this.taskService.switchAutomations(id, param).subscribe((res: any) => {});
  }
  getInstanceId(id) {
    this.currentInstanceId = id;
  }
  // 删除实例
  deleteInstance(id) {
    this.dataSubscription = this.taskService.deleteAutomations(id).subscribe((res: any) => {
      this.message.create('success', '删除成功！');
      if (this.listType === 'card') {
        this.getAutomationsData();
      } else {
        this.getAutomationPagesData();
      }
    });
  }
  // 修改实例
  handleInstanceEditEvent(item) {
    this.isVisible = true;
    this.currentInstanceId = item.id;
    this.categorieId = item.config.categoryId;
    let smsPattern = 'custom';
    let selectedRecipe;
    for (const recipe of this.recipeAllData) {
      if (item.config.relationId === recipe.relationId) {
        selectedRecipe = recipe;
        smsPattern = recipe.smsPattern;
        break;
      }
    }
    this.createComponent(item.partCode, selectedRecipe, item.recipeId, item.config.relationId, item, true, smsPattern);
  }
  // 关键字搜索
  doSearch() {
  }
  // 列表切换
  listTypeChange(type) {
    this.listType = type;
    if (this.listType === 'card') {
      this.getAutomationsData();
    } else {
      this.getAutomationPagesData();
    }
  }
}
